function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4225 3.7824C14.4895 3.69206 14.5665 3.60914 14.6394 3.52344C15.4677 2.54908 14.7845 1 13.4506 1H7.15833C6.71537 1 6.29368 1.18901 6.00018 1.51912L1.39114 8.44219C0.508296 9.43515 1.21684 11 2.54928 11H2.83863C4.03966 11 4.74546 12.2796 4.20167 13.2679C4.11012 13.4342 4.00421 13.594 3.9307 13.7691L1.66735 19.1595C1.59384 19.3346 1.48246 19.4928 1.40985 19.6683C1.15917 20.274 1.59586 21 2.31354 21C2.49809 21 2.67883 20.9478 2.83468 20.8495L12.33 13.395C13.4335 12.6987 12.9378 11 11.6312 11C10.5146 11 9.93828 9.71391 10.611 8.89055C10.6821 8.80344 10.7596 8.72087 10.8266 8.63053L14.4225 3.7824Z",
  stroke: "#A9AFBF",
  strokeWidth: 1.4
});

var SvgActivities = function SvgActivities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activities.f3c2e025.svg";
export { ForwardRef as ReactComponent };